import { render, staticRenderFns } from "./IndexGuideItems.vue?vue&type=template&id=0c835c06&"
import script from "./IndexGuideItems.vue?vue&type=script&lang=js&"
export * from "./IndexGuideItems.vue?vue&type=script&lang=js&"
import style0 from "./IndexGuideItems.vue?vue&type=style&index=0&id=0c835c06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports